import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { ErrorMessage, SalesPortalConfiguration, SalesPortalConfigurationWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateSalesPortalConfiguration(): UseMutationResult<
  AxiosResponse<SalesPortalConfiguration>,
  AxiosError<ErrorMessage>,
  Omit<SalesPortalConfigurationWrite, 'file'> & { file: File | null }
> {
  const queryClient = useQueryClient();

  const updateSalesPortalConfiguration = useCallback(
    (
      salesPortalConfiguration: Omit<SalesPortalConfigurationWrite, 'file'> & { file: File | null },
    ): Promise<AxiosResponse<SalesPortalConfiguration>> => {
      const formData = new FormData();
      formData.append('file', salesPortalConfiguration.file || '');
      formData.append('google_tracking', salesPortalConfiguration.googleTracking || '');
      formData.append('facebook_tracking', salesPortalConfiguration.facebookTracking || '');
      formData.append('home_page_text', salesPortalConfiguration.homePageText || '');
      formData.append('slug', salesPortalConfiguration.slug);
      formData.append('enabled', salesPortalConfiguration.enabled);
      formData.append('sales_portal_configuration_id', salesPortalConfiguration.salesPortalConfigurationId);
      return client.put(
        `sales-portal-configurations/${salesPortalConfiguration.salesPortalConfigurationId}/`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );
    },
    [],
  );

  return useMutation(updateSalesPortalConfiguration, {
    onSuccess: () => {
      queryClient.invalidateQueries(['salesPortalConfigurations']);
    },
  });
}
